<template>
	<div class="empower">
		<div class="brandReg_top">
			<div class="empower_title">企业商标注册量</div>
            <div class="powerList">
                <div class="powerItem" v-for="(item,index) in powerList" :key="index">
                    <div class="title">{{item.title}}</div>
                    <div class="piece">
                        <countTo  :startVal='0' :endVal='Number(item.piece)' :duration='800'/>{{item.unit}}
                    </div>
                </div>
            </div>
		</div>
        <dv-decoration-10 class="dv_line"/>
		<div class="brandReg_top">
			<div class="empower_title">企业商标有效注册量</div>
            <div class="powerList">
                <div class="powerItem" v-for="(item,index) in effectList" :key="index">
                    <div class="title">{{item.title}}</div>
                    <div class="piece">
                        <countTo  :startVal='0' :endVal='Number(item.piece)' :duration='800'/>{{item.unit}}
                    </div>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
    export default {
        data(){
            return{
                powerList:[],
                effectList:[],
            }
        },
		methods:{
			getData(data){
				this.powerList = [
				    {
				        title:'企业数',
				        piece:data.sb_qy_zhuc_qy,
						unit:'家',
				    }, {
				        title:'商品类',
				        piece:data.sb_qy_zhuc_shangp,
						unit:'件',
				    }, {
				        title:'服务类',
				        piece:data.sb_qy_zhuc_fuw,
						unit:'件',
				    },
				]
				this.effectList = [
				    {
				        title:'企业数',
				        piece:data.sb_qy_youx_qy,
						unit:'家',
				    },{
				        title:'商品类',
				        piece:data.sb_qy_youx_shangp,
						unit:'件',
				    },{
				        title:'服务类',
				        piece:data.sb_qy_youx_fuw,
						unit:'件',
				    },
				]
			},
		}
    }
</script>

<style>
</style>